import { lazy } from 'react';

const RipplingPromotionDialog = lazy(() => import('./RipplingPromotionDialog'));
const RipplingPostConversionDialog = lazy(() => import('./RipplingPostConversionDialog'));
const RipplingPhoneCollectionDialog = lazy(() => import('./RipplingPhoneCollectionDialog'));
const RipplingPlatformAnnouncementDialog = lazy(() => import('./RipplingPlatformAnnouncementDialog'));

// Identifiers for each dialog
export const RIPPLING_PROMOTION_DIALOG = 'RIPPLING_PROMOTION_DIALOG';
export const RIPPLING_POST_CONVERSION_DIALOG = 'RIPPLING_POST_CONVERSION_DIALOG';
export const RIPPLING_PHONE_COLLECTION_DIALOG = 'RIPPLING_PHONE_COLLECTION_DIALOG';
export const RIPPLING_PLATFORM_ANNOUNCEMENT_DIALOG = 'RIPPLING_PLATFORM_ANNOUNCEMENT_DIALOG';

const ripplingDialogs = {
  [RIPPLING_PROMOTION_DIALOG]: RipplingPromotionDialog,
  [RIPPLING_POST_CONVERSION_DIALOG]: RipplingPostConversionDialog,
  [RIPPLING_PHONE_COLLECTION_DIALOG]: RipplingPhoneCollectionDialog,
  [RIPPLING_PLATFORM_ANNOUNCEMENT_DIALOG]: RipplingPlatformAnnouncementDialog,
};

export default ripplingDialogs;
